export function MarkHotkey({ type, key }) {
  return {
    // eslint-disable-next-line
    onKeyDown(event, editor, next) {
      const modKeyPressed = event.metaKey || event.ctrlKey;
      if (!modKeyPressed || event.key !== key) {
        return next();
      }
      editor.toggleMark(type);
    },
  };
}
